import { useState, useEffect } from 'react';
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext';
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import YandexMap from '../../../components/YandexMap/YandexMap';
import Link from "../../../components/Link/Link";
import style from './mapblock.module.scss';

const MapBlock = ({ facility }) => {
    const [isMobile, setIsMobile] = useState(false);
    const { settings: { contrast } } = useAccessibility();

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Функция для получения координат филиала
    const getFacilityCoordinates = () => {
        if (!facility || !facility.attributes) return null;

        // Сначала пробуем получить coordinates
        if (facility.attributes.coordinates) {
            return facility.attributes.coordinates;
        }
        // Если coordinates нет, используем map_x и map_y
        if (facility.attributes.MapY && facility.attributes.MapX) {
            return [facility.attributes.MapY, facility.attributes.MapX];
        }
        
        return null;
    };

    const coordinates = getFacilityCoordinates();

    // Fallback координаты, если нет данных
    const defaultCoordinates = [45.0355, 38.9750]; // Координаты Краснодара

    console.log('Facility data:', facility);
    console.log('Facility coordinates:', coordinates);
    console.log('Facility Email:', facility?.attributes?.Email);

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width={isMobile ? '100%' : '75%'}
            height='fit-content'
            background={contrast !== 'default' ? 'var(--bg-primary)' : 'rgba(255, 255, 255, 0.85)'}
            header='РАСПОЛОЖЕНИЕ ФИЛИАЛА'
            id='location'
            padding={isMobile ? '1rem' : '2rem'}
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        <div className={style.row}>
                            <div className={style.infoColumn}>
                                <h4 className={style.header}>{facility?.attributes?.Title || facility?.attributes?.Name || 'Название филиала'}</h4>
                                <div className={style.text}>
                                    <p><strong>Адрес:</strong> {facility?.attributes?.Address || 'Адрес не указан'}</p>
                                    <p><strong>Контактный телефон:</strong> {facility?.attributes?.Phone || 'Телефон не указан'}</p>
                                    {facility?.attributes?.Email && (
                                        <p>
                                            <strong>Email:</strong>{' '}
                                            <Link 
                                                href={`mailto:${facility.attributes.Email}`} 
                                                children={facility.attributes.Email} 
                                            />
                                        </p>
                                    )}
                                    {coordinates && (
                                        <p className={style.coordinates}>
                                            <strong>Координаты:</strong> {coordinates[0]?.toFixed(6)}, {coordinates[1]?.toFixed(6)}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className={style.mapColumn}>
                                <YandexMap
                                    width='100%'
                                    height={isMobile ? '300px' : '400px'}
                                    center={coordinates || defaultCoordinates}
                                    zoom={15}
                                    branches={coordinates ? [{
                                        id: facility?.id,
                                        attributes: {
                                            Title: facility?.attributes?.Title || facility?.attributes?.Name,
                                            Address: facility?.attributes?.Address,
                                            coordinates: coordinates
                                        }
                                    }] : []}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </FadeIn>
        </Block>
    );
};

export default MapBlock;